class APE {
    constructor(data) {
      this.name = data.Name;
      this.code = data.Code;
    }
  }
  
  export default APE;
  